/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { DistillationColumnB } from "./modelDistillationColumnB";

class ControllerDistillationColumnB extends ControllerModel {
  constructor() {
    super("ControllerDistillationColumnB");

    this.setNewNode = (callback) => {
      let distillationColumnB = new DistillationColumnB();
      distillationColumnB.decorate(callback);

      this.addNode(distillationColumnB);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let distillationColumnB = new DistillationColumnB();
      distillationColumnB.copyFrom(node);
      distillationColumnB.decorate(callback);
      this.addNode(distillationColumnB);
    };

    this.getProperties = async (node) => {
      let n = new DistillationColumnB();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new DistillationColumnB();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerDistillationColumnB };
